import React from "react";

export default function Pilot() {
  return (
    <section className="bg-blue-50 py-20 px-6" id="pilot">
      <div className="max-w-5xl mx-auto text-center">
        <h2 className="text-3xl md:text-4xl font-bold mb-6">
          Join the BenefitChain Pilot Program
        </h2>
        <p className="text-gray-700 text-lg max-w-2xl mx-auto mb-12">
          We're inviting a select group of forward-thinking self-insured employers to help shape the future of benefit delivery.
        </p>
        <div className="grid md:grid-cols-2 gap-8 text-left mb-12">
          {/* Pilot Candidate Profile */}
          <div className="bg-white p-6 rounded-lg shadow-md">
            <h3 className="text-xl font-semibold mb-3 text-blue-700">Pilot Candidate Profile</h3>
            <ul className="list-disc list-inside text-gray-700 space-y-2">
              <li>500–5,000 employees</li>
              <li>Self-insured healthcare plan</li>
              <li>Currently offering voluntary benefits</li>
              <li>Open to integrating HRIS or claims data</li>
              <li>Comfortable with digital wallets/tokenization</li>
            </ul>
          </div>
          {/* Pilot Timeline */}
          <div className="bg-white p-6 rounded-lg shadow-md">
            <h3 className="text-xl font-semibold mb-3 text-blue-700">Pilot Timeline</h3>
            <ul className="list-disc list-inside text-gray-700 space-y-2">
              <li>Month 1: Employer onboarding + configuration</li>
              <li>Months 2–4: Employee enrollment + wallet funding</li>
              <li>Months 5–6: Live usage + analytics review</li>
            </ul>
          </div>
        </div>
        <p className="text-gray-700 text-base mb-8 max-w-2xl mx-auto">
          Pilot participants receive tailored implementation support, access to the admin dashboard, AI onboarding agents, and early insights into utilization trends.
        </p>
        <div className="text-sm text-gray-700">
          To express interest, email us at{' '}
          <a href="mailto:info@missiontechdev.com" className="text-blue-700 underline">info@missiontechdev.com</a>
        </div>
      </div>
    </section>
  );
} 